export const navItems = [
  { id: "about", text: "About", path: "/" },
  { id: "SDGs&Projects", text: "SDGs & Projects", path: "SDGs&Projects" },
  { id: "courses", text: "Courses", path: "courses" },
  { id: "activities", text: "Activities", path: "activities" },
  { id: "sonferences", text: "Conferences", path: "conferences" },
  { id: "initiatives", text: "Initiatives", path: "initiatives" },
  // { id: "publications", text: "Publications", path: "publications" },
  { id: "contact-us", text: "Contact Us", path: "contact-us" },
  { id: "donate", text: "Donate", path: "donates" },
];
